export default "__VITE_ASSET__BlYPIBpU__"